import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject, Subscription } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Tecnologia } from 'src/app/models/Tecnologia';
import { catchError } from 'rxjs/operators';
import { httpOptions } from "./headers";


@Injectable({
  providedIn: 'root'
})

// Class responsible for communicating with the backend api related with Tecnologias.
export class TecnologiasService {

  private backOfficeURL = environment.catalogUrl;
  private addTechUrl = environment.addTech;


  private httpOptions(session: string) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + session
      }),
    };
  };

  constructor(private http: HttpClient) { }

  getTecnologias(): Observable<Tecnologia> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.backOfficeURL, this.httpOptions(token));
  }

  getUserTechnologies(): Observable<Tecnologia> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.backOfficeURL + '/all', this.httpOptions(token));
  }

  getCompletedTecnologias(): Observable<Tecnologia> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.backOfficeURL + '/completed', this.httpOptions(token));
  }

  getCompletedTecnologiasGeneric(): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.backOfficeURL + '/completedGeneric', this.httpOptions(token));
  }

  addTecnologia(tech: Tecnologia): Observable<Tecnologia> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.post<Tecnologia>(this.addTechUrl, tech, this.httpOptions(token)).pipe(
      catchError(this.handleError)
    );
  }

  removeCatalog(catalogID: string): Observable<Tecnologia> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.delete<Tecnologia>(this.backOfficeURL + '/' + catalogID + '/delete', this.httpOptions(token));
  }

  updateCatalog(tech: Tecnologia, catalogID: string) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;

    return this.http.put<Tecnologia>(this.backOfficeURL + '/' + catalogID + '/edit-configurations', tech, this.httpOptions(token))
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }


} 